<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-tabs v-model="tab">
          <v-tab :key="PLACEMENTS">
            Placements
          </v-tab>
          <v-tab :key="FALLOFFS">
            Falloffs
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item :key="PLACEMENTS">
            <v-container fluid class="pa-0 ma-0">
              <v-data-table
                dense
                :headers="placementsHeaders"
                :items="placements"
                :calculate-widths="true"
              >
                <template v-slot:item.startAt="{ item }">
                  {{ item.startAt | formatDate }}
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-btn
                    class="mx-1 my-1 hide-on-print"
                    color="primary"
                    outlined
                    @click.prevent="viewAssignment($event, item)"
                  >
                    <v-icon color="primary">badge</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-container>
          </v-tab-item>
          <v-tab-item :key="FALLOFFS">
            <v-data-table
                dense
                :headers="fallOffsHeaders"
                :items="fallOffs"
                :calculate-widths="true"
              >
                <template v-slot:item.endAt="{ item }">
                  {{ item.endAt | formatDate }}
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-btn
                    class="mx-1 my-1 hide-on-print"
                    color="primary"
                    outlined
                    @click.prevent="viewAssignment($event, item)"
                  >
                    <v-icon color="primary">badge</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { assignmentEditRoute } from '@/lib/constants/routes'

export default {
  props: [
    'placements',
    'fallOffs'
  ],
  data () {
    return {
      tab: 0,
      PLACEMENTS: 0,
      FALLOFFS: 1,
      placementsHeaders: [
        { text: 'Client', value: 'clientName', width: '150px' },
        { text: 'Consultant', value: 'userFullName', width: '150px' },
        { text: 'Started On', value: 'startAt', width: '130px', align: 'center' },
        { text: 'Contract', value: 'actions', width: '130px', align: 'center', sortable: false }
      ],
      fallOffsHeaders: [
        { text: 'Client', value: 'clientName', width: '150px' },
        { text: 'Consultant', value: 'userFullName', width: '150px' },
        { text: 'Ended On', value: 'endAt', width: '130px', align: 'center' },
        { text: 'Contract', value: 'actions', width: '130px', align: 'center', sortable: false }
      ]
    }
  },
  methods: {
    viewAssignment (event, item) {
      const routeData = this.$router.resolve({ name: assignmentEditRoute.name, params: { id: item.id } })
      if (event.ctrlKey === true) {
        window.open(routeData.href, '_blank')
      } else {
        window.open(routeData.href, '_self')
      }
    }
  }
}
</script>
